import { PaperSection, Flex } from '@shared/components';

import { ItemAnalysisYearlyReportExportButton } from '../..';
import { ItemAnalysisFilterYearlySection } from '../item-analysis-yearly-filter-section';
import { ItemAnalysisYearlyTable } from '../item-analysis-yearly-table';

export default function ItemAnalysisYearlyList() {
  return (
    <PaperSection
      title='รายงานวิเคราะห์คุณภาพข้อสอบ: แบบรายปี'
      endAdornment={<ItemAnalysisYearlyReportExportButton />}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          gap: (theme) => theme.spacing(6),
          p: (theme) => theme.spacing(4),
        }}
      >
        <ItemAnalysisFilterYearlySection />
        <ItemAnalysisYearlyTable />
      </Flex>
    </PaperSection>
  );
}
